import {ReactNode} from "react";
import classNames from "classnames";

import {useResponsiveModalPartRef} from "./ResponsiveModalContext";

import * as styles from "./ResponsiveModal.module.css";

export interface IResponsiveModalHeaderProps {
    children: ReactNode;
    className?: string;
    divider?: boolean;
}

export const ResponsiveModalHeader = (props: IResponsiveModalHeaderProps) => {
    const {children, className, divider = true} = props;
    const headerRef = useResponsiveModalPartRef("header");

    return (
        <div ref={headerRef} className={classNames(styles.header, divider && styles.headerDivider, className)}>
            {children}
        </div>
    );
};
import {ReactNode} from "react";
import classNames from "classnames";

import {useResponsiveModalPartRef} from "./ResponsiveModalContext";

import * as styles from "./ResponsiveModal.module.css";

export interface IResponsiveModalHeaderProps {
    children: ReactNode;
    className?: string;
    divider?: boolean;
}

export const ResponsiveModalHeader = (props: IResponsiveModalHeaderProps) => {
    const {children, className, divider = true} = props;
    const headerRef = useResponsiveModalPartRef("header");

    return (
        <div ref={headerRef} className={classNames(styles.header, divider && styles.headerDivider, className)}>
            {children}
        </div>
    );
};
